<div class="revocation-after__row" id="revocationAfterHeader">
  <div class="revocation-after__content col-12">
    <p class="revocation-after__received"
       [innerHTML]="translationService.getTranslation('revocation_received_message')"></p>
  </div>
</div>
